/**
 * Available Page Background Design.
 * @public
 */
enum PageBackgroundDesign {

	/**
	 * Page background color when a List is set as the Page content.
	 * @public
	 */
	List = "List",

	/**
	 * A solid background color dependent on the theme.
	 * @public
 	 */
	Solid = "Solid",

	/**
	 * Transparent background for the page.
	 * @public
	 */
	Transparent = "Transparent",
}

export default PageBackgroundDesign;
